import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import PropTypes from 'prop-types';
import useCopyToClipboard from '../../../useCopyToClipboard';
import './CopyLink.scss';
function CopyLink(_ref) {
  var url = _ref.url,
    _ref$shortForm = _ref.shortForm,
    shortForm = _ref$shortForm === void 0 ? false : _ref$shortForm,
    _ref$linkText = _ref.linkText,
    linkText = _ref$linkText === void 0 ? 'Copy link' : _ref$linkText;
  var _useCopyToClipboard = useCopyToClipboard(),
    _useCopyToClipboard2 = _slicedToArray(_useCopyToClipboard, 2),
    status = _useCopyToClipboard2[0],
    copy = _useCopyToClipboard2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "copy-link-container"
  }, !shortForm && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "copy-link-url"
  }, "Copy link to send invites manually")), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, !shortForm && /*#__PURE__*/React.createElement("div", {
    className: "col-xs-8"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    id: "copy-link-url",
    type: "text",
    value: url,
    readOnly: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-4"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-link btn-xs copy-link copy-link--".concat(status),
    onClick: function onClick() {
      return copy(url);
    }
  }, status === 'copied' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-check"
  }), ' ', "Copied!"), status === 'failed' && 'Copy failed, please try again', status === 'idle' && linkText))));
}
CopyLink.propTypes = {
  url: PropTypes.string.isRequired,
  shortForm: PropTypes.bool,
  linkText: PropTypes.string
};
export default CopyLink;